import { Tag } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

export const PayableTableTitle = ({
  className = '',
  title,
  count,
}: {
  className?: string;
  title: ReactNode;
  count?: number;
}) => {
  return (
    <div className={`flex items-center gap-12 ${className}`}>
      <h2 className="heading-l">{title}</h2>
      {count !== undefined && (
        <Tag variant="purple" className="min-w-32 text-content-brand-default">
          {count}
        </Tag>
      )}
    </div>
  );
};
